/* eslint-disable no-prototype-builtins */
function hasFile(input: any): boolean {
  if (input instanceof File || input instanceof Blob) {
    return true;
  }

  if (Array.isArray(input)) {
    return input.some(item => hasFile(item));
  }

  if (typeof input === 'object' && input !== null) {
    return Object.values(input).some(value => hasFile(value));
  }

  return false;
}

function objectToFormData(input: any, form: FormData = new FormData(), namespace = ''): FormData {
  if (input instanceof File || input instanceof Blob) {
    form.append(namespace, input);
  } else if (Array.isArray(input)) {
    input.forEach((item, index) => {
      const key = `${namespace}[${index}]`;
      objectToFormData(item, form, key);
    });
  } else if (typeof input === 'object' && input !== null) {
    for (const key in input) {
      if (input.hasOwnProperty(key) && typeof input[key] !== 'undefined') {
        const formKey = namespace ? `${namespace}[${key}]` : key;
        objectToFormData(input[key], form, formKey);
      }
    }
  } else if (namespace) {
    form.append(namespace, input);
  }

  return form;
}

export function appendFormData<T extends Record<string, any>>(json: T): T | FormData {
  if (hasFile(json)) {
    return objectToFormData(json);
  } else {
    return json;
  }
}
